var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"h4"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"h5 font-weight-300"},[_vm._v("\n    "+_vm._s(_vm.description)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }